// ===============================
// About Wassla Modal Content
// Professional Version (EN + AR)
// ===============================

import { BRAND } from '../constants/brand';

export const ABOUT_WASSLA_CONTENT = {
  en: {
    title: "About Wassla",
    tagline: BRAND.slogan.en, // "One Link. Many Opportunities."
    sections: [
      {
        heading: "Why Wassla?",
        text: `Wassla is built to connect people with verified opportunities, trusted services, and real local markets — all within one secure and reliable platform.

We focus on transparency, reliability, and community trust. Every listing is structured to be clear, accessible, and relevant to local needs.

Whether you're buying, selling, or offering services, Wassla helps you connect with confidence.`
      },
      {
        heading: "Our Values",
        bullets: [
          "Trust & safety first",
          "Built for local communities",
          "Fair access for everyone",
          "Clear and transparent listings"
        ]
      },
      {
        heading: "Our Mission",
        text: `To create a professional, community-driven marketplace where people can exchange value safely, discover real opportunities, and grow their local networks with confidence.`
      }
    ],
    button: "Close"
  },

  ar: {
    title: "عن وصلة",
    tagline: BRAND.slogan.ar, // "رابط واحد، فرص متعددة"
    sections: [
      {
        heading: "لماذا وصلة؟",
        text: `وصلة صُممت لتجمع بين الناس والفرص الموثوقة والخدمات المضمونة والأسواق المحلية الحقيقية — في منصة واحدة آمنة واحترافية.

نحن نؤمن بالشفافية، والموثوقية، وبناء الثقة داخل المجتمع. كل إعلان يتم عرضه بطريقة واضحة وسهلة الوصول، ومناسبة لاحتياجات السوق المحلي.

سواء كنت تشتري، تبيع، أو تقدم خدمة — وصلة تمنحك تجربة تواصل بثقة واطمئنان.`
      },
      {
        heading: "قيمنا",
        bullets: [
          "الثقة والأمان أولاً",
          "منصة مبنية لخدمة المجتمع المحلي",
          "فرص عادلة ومتاحة للجميع",
          "إعلانات واضحة وشفافة"
        ]
      },
      {
        heading: "مهمتنا",
        text: `بناء سوق رقمي احترافي يقوده المجتمع، يتيح تبادل القيمة بأمان، واكتشاف فرص حقيقية، وتنمية العلاقات المحلية بثقة واستقرار.`
      }
    ],
    button: "إغلاق"
  }
};

// ========================================
// Premium + Minimal About Wassla Versions
// ========================================

export const ABOUT_WASSLA_REFINED = {
  premium: {
    en: {
      tagline: "A trusted local marketplace built for secure connections and real opportunities.",
      why: `Wassla connects people to verified opportunities, trusted services, and authentic local markets — all within one secure, community-driven platform.

Designed with transparency and reliability at its core, Wassla empowers users to buy, sell, and offer services with clarity and confidence.`,
    },
    ar: {
      tagline: "سوق محلي موثوق يجمع بين الأمان والفرص الحقيقية.",
      why: `وصلة تربط الناس بالفرص الموثوقة والخدمات المضمونة والأسواق المحلية الحقيقية — في منصة واحدة آمنة يقودها المجتمع.

بُنيت وصلة على أسس الشفافية والموثوقية، لتمنح المستخدمين تجربة بيع وشراء وتقديم خدمات بثقة ووضوح.`
    }
  },

  minimalist: {
    en: {
      tagline: "Secure. Local. Trusted.",
      why: `Wassla is a community-driven marketplace connecting people to real services and real opportunities — simply and safely.`
    },
    ar: {
      tagline: "آمن. محلي. موثوق.",
      why: `وصلة منصة مجتمعية تجمع بين الناس والفرص والخدمات الحقيقية — ببساطة وأمان.`
    }
  }
};

export default ABOUT_WASSLA_CONTENT;
